<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/w4Lj50/tc-custom/cover.jpg" alt="This image is the cover for the book The Greatest Transition In Human History"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Greatest Transition In Human History
      </h1>
      <p class="bookDescription body article font2">
        <p>Knowledge is power. Real truth is freedom. Freedom is what our Founding Fathers wanted to create as the beacon of light to the world in 1776. America was to be the example of what humanity could be. Was that really achieved? The Greatest Transition in Human History tells the real story of America over the past over 200 years - the heartbreak, false-flag wars, hidden technology, power, corruption, and manipulation. Does the American citizen have real Freedom as the great Constitution and Bill of Rights intended? The Greatest Transition in Human History is the real emotion story of great Americans and patriots standing up for these great rights. These freedoms were taken for granted by so many - for many fell asleep and did not participate as much as we should have, including myself for many years. No more, for I work for humanity, and freedom. I want that real Freedom Bell to ring for all. For in the oath to a military person sworn in to our armed forces, they are to fight any enemy both foreign and domestic. The Greatest Transition in Human History is the story of brave people standing up for individual freedoms and rights worldwide, in the Greatest Secret War ever.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark Baughman
      </h2>
      
      <p class="authorDescription body article">Mark Baughman, raised in Midwest America, was ingrained with values of morality, family, and drive to succeed. He graduated from two universities. Mark is a parent, husband, an American, and an engineer with a mind to seek the unknown, and to question everything! Because real intelligence isn't knowing everything; it is the ability to challenge everything known! He was a technician and then an engineer for the medical industry for almost 40 years. During a lot of travel and overnight hotels, he continued to study and learn in the high-speed tech world. The most interesting thing was the secret technology our government was developing! In books and internet; high technology would pop-up at different times, but one would have to capture the knowledge in a short amount of time. He learned many technologies were being held back or suppressed that would allow humanity to make a giant leap forward. Mark studied and became extremely familiar with a clean technology for continuous power called Zero Point Energy. He built a prototype and began making presentations and proposals on this technology. Until the day, Mark learned of a Secret Group to change all technology world-wide and to stop this suppression. He joined the group. The rest will be in history in a few years, to advance humanity to technology that will take us to the stars!</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Publication Consultants
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?03685a18